import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const useGlobalCopy = (selectedHistory) => {
  const navigate = useNavigate();
  
  const [globalCopyModal, setGlobalCopyModal] = useState({
    open: false,
    videoTitle: ''
  });

  // 광역 복사 모달 처리 - URL 쿼리 파라미터로 광역 복사 여부 확인
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const isGlobalCopy = urlParams.get('globalCopy') === 'true';
    const isExistingHistory = urlParams.get('existingHistory') === 'true';
    const videoTitle = urlParams.get('videoTitle') || '';
    
    if (isGlobalCopy && selectedHistory) {
      // 모달 열기
      setGlobalCopyModal({
        open: true,
        videoTitle: decodeURIComponent(videoTitle)
      });
      
      // 1.4초 후 모달 닫기 (0.2초 × 4단계 + 0.5초 마지막 대기 + 0.1초 여유)
      setTimeout(() => {
        setGlobalCopyModal({ open: false, videoTitle: '' });
        
        // URL에서 쿼리 파라미터 제거
        const newUrl = window.location.pathname;
        window.history.replaceState(null, '', newUrl);
      }, 1400);
    } else if (isExistingHistory && selectedHistory) {
      // URL에서 쿼리 파라미터 제거 (즉시)
      const newUrl = window.location.pathname;
      window.history.replaceState(null, '', newUrl);
    }
  }, [selectedHistory]);

  // 광역 복사 네비게이션 헬퍼
  const handleGlobalCopyNavigation = (result) => {
    if (result && result.historyId) {
      // 광역 복사인 경우 쿼리 파라미터와 함께 이동
      if (result.copiedFromGlobal) {
        const videoTitle = encodeURIComponent(result.videoTitle || '');
        navigate(`/analyze/${result.historyId}?globalCopy=true&videoTitle=${videoTitle}`);
        return true;
      }
      // 기존 히스토리인 경우 쿼리 파라미터와 함께 이동
      if (result.existingHistory) {
        const videoTitle = encodeURIComponent(result.videoTitle || '');
        navigate(`/analyze/${result.historyId}?existingHistory=true&videoTitle=${videoTitle}`);
        return true;
      }
    }
    return false;
  };

  // 모달 닫기 헬퍼
  const closeGlobalCopyModal = () => {
    setGlobalCopyModal({ open: false, videoTitle: '' });
  };

  const openGlobalCopyModal = (videoTitle) => {
    setGlobalCopyModal({ 
      open: true, 
      videoTitle: videoTitle 
    });
  };

  return {
    globalCopyModal,
    setGlobalCopyModal,
    handleGlobalCopyNavigation,
    closeGlobalCopyModal,
    openGlobalCopyModal
  };
}; 